<template>
	<div>
		<section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>{{ $t('label.home') }}</h3>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item active">{{ $t("label.home")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>

		<section class="content">
			<div class="container-fluid">

				<!-- <div class="callout callout-success" v-if="user && user.data.is_officer==false">
					<br>
					<workflow-process />
				</div> -->
				
				<template v-if="user && user.data.is_officer">
					<OfficerDashboard/>
				</template>

				<template v-else>
					<UserDashboard :profile="profile"/>
				</template>

			</div>
		</section>
	</div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";

import { mapState, createNamespacedHelpers } from "vuex";
import OfficerDashboard from "./dashboard/OfficerDashboard";
import UserDashboard from "./dashboard/UserDashboard";
export default {
	components: {
		UserDashboard,
		OfficerDashboard,
    },
	name: 'Home',
	data(){
		return {
			profile: {},
			chart_data_loaded: false,
			declaration_chart: null,
			vehicle_chart: null,
			entry_vehicles: [],
			exit_vehicles: [],
			applications : [],
			over_stay_applications : [],
			total_declaration: 0,
			total_vehicle: 0,
			chart_line: true,

			import_page: 1,
			import_forcepage: 1,
			import_pageNumber:1,
			import_current_page: 1,
			import_last_page: 0,
			import_order_by:'created_at',
			import_order_type:'asc',
			import_order_type_after_sort:'',

			export_page: 1,
			export_forcepage: 1,
			export_pageNumber:1,
			export_current_page: 1,
			export_last_page: 0,
			export_order_by:'created_at',
			export_order_type:'asc',
			export_order_type_after_sort:'',

			declaration_page: 1,
			declaration_forcepage: 1,
			declaration_pageNumber:1,
			declaration_current_page: 1,
			declaration_last_page: 0,
			declaration_order_by:'created_at',
			declaration_order_type:'asc',
			declaration_order_type_after_sort:'',

			over_stay_page: 1,
			over_stay_forcepage: 1,
			over_stay_pageNumber:1,
			over_stay_current_page: 1,
			over_stay_last_page: 0,
			over_stay_order_by:'created_at',
			over_stay_order_type:'asc',
			over_stay_order_type_after_sort:'',
		}
	},
	computed: {
        fas() {
            return fas;
		},
		...mapState("user", ["user"])
	},
	mounted() {
		this.getProfile();
		// this.getApplicationStatus(1,'created_at', 'asc');
		// this.getOverStayApplications(1,'created_at', 'asc');
		// this.totalDeclaration();
		// this.totalVehicle();

	},
	methods: {
		getProfile() {
            this.$store.state.loading.status = true;
            GDCE_Client.requestApi("GET",'profile').then(response => {
				this.profile = response.data;
				if(response.data.is_officer) {
					// this.getEntryVehicles(1,'created_at', 'asc');
					// this.getExitVehicles(1,'created_at', 'asc');
					// this.initDeclarationChart();
					// this.initVehicleChart();
				}
				this.$store.state.loading.status = false; 
            });
		},
		totalDeclaration(){
			let url = 'dashboard/total-declaration';
			GDCE_Client.requestApi("GET",url).then(response => {
				this.total_declaration = response.data;
			}).catch(error => {
				console.log(error);
			})
		},
		totalVehicle(){
			let url = 'dashboard/total-vehicle';
			GDCE_Client.requestApi("GET",url).then(response => {
				this.total_vehicle = response.data;
			}).catch(error => {
				console.log(error);
			})
		},
		switchToLine(){
			this.chart_line = true;
		},
		switchToBar(){
			this.chart_line = false;
		},
		initDeclarationChart(){
			GDCE_Client.requestApi("GET","dashboard/chart/declaration").then(response => {
				let entry = [
					response.data.entry.Jan,
					response.data.entry.Feb,
					response.data.entry.Mar,
					response.data.entry.Apr,
					response.data.entry.May,
					response.data.entry.Jun,
					response.data.entry.Jul,
					response.data.entry.Aug,
					response.data.entry.Sep,
					response.data.entry.Oct,
					response.data.entry.Nov,
					response.data.entry.Dec
				]
				let exit = [
					response.data.exit.Jan,
					response.data.exit.Feb,
					response.data.exit.Mar,
					response.data.exit.Apr,
					response.data.exit.May,
					response.data.exit.Jun,
					response.data.exit.Jul,
					response.data.exit.Aug,
					response.data.exit.Sep,
					response.data.exit.Oct,
					response.data.exit.Nov,
					response.data.exit.Dec
				]
				this.declaration_chart = {
					labels  : Object.values(this.$root.$i18n.t('label.months')),
					datasets: [
						{
							label               : this.$root.$i18n.t('label.entry'),
							backgroundColor		: 'rgba(230, 51, 51, 0.5)',
							fillColor           : 'rgba(210, 214, 222, .5)',
							strokeColor         : 'rgba(210, 214, 222, 1)',
							pointColor          : 'rgba(210, 214, 222, 1)',
							pointStrokeColor    : '#c1c7d1',
							pointHighlightFill  : '#fff',
							pointHighlightStroke: 'rgba(220,220,220,1)',
							data                : entry
						},{
							label               : this.$root.$i18n.t('label.exit'),
							backgroundColor		: 'rgba(209, 51, 230, 0.7)',
							fillColor           : 'rgba(209, 51, 230, 0.7)',
							strokeColor         : 'rgba(209, 51, 230, 0.7)',
							pointColor          : '#3b8bba',
							pointStrokeColor    : 'rgba(60,141,188,1)',
							pointHighlightFill  : '#fff',
							pointHighlightStroke: 'rgba(60,141,188,1)',
							data                : exit
						}
					]
				}
				this.chart_data_loaded = true;
			})
		},
		initVehicleChart(){
			GDCE_Client.requestApi("GET","dashboard/chart/vehicle").then( response => {				
				let vehicle_entry = [
					response.data.entry.Jan,
					response.data.entry.Feb,
					response.data.entry.Mar,
					response.data.entry.Apr,
					response.data.entry.May,
					response.data.entry.Jun,
					response.data.entry.Jul,
					response.data.entry.Aug,
					response.data.entry.Sep,
					response.data.entry.Oct,
					response.data.entry.Nov,
					response.data.entry.Dec
				]
				let vehicle_exit = [
					response.data.exit.Jan,
					response.data.exit.Feb,
					response.data.exit.Mar,
					response.data.exit.Apr,
					response.data.exit.May,
					response.data.exit.Jun,
					response.data.exit.Jul,
					response.data.exit.Aug,
					response.data.exit.Sep,
					response.data.exit.Oct,
					response.data.exit.Nov,
					response.data.exit.Dec
				]
				this.vehicle_chart = {
					labels  : Object.values(this.$root.$i18n.t('label.months')),
					datasets: [
						{
							label               : this.$root.$i18n.t('label.entry'),
							backgroundColor		: '#17a2b8',
							fillColor           : 'rgba(210, 214, 222, 1)',
							strokeColor         : 'rgba(210, 214, 222, 1)',
							pointColor          : 'rgba(210, 214, 222, 1)',
							pointStrokeColor    : '#c1c7d1',
							pointHighlightFill  : '#fff',
							pointHighlightStroke: 'rgba(220,220,220,1)',
							data                : vehicle_entry
						},
						{
							label               : this.$root.$i18n.t('label.exit'),
							backgroundColor		: '#6610f2',
							fillColor           : 'rgba(60,141,188,0.9)',
							strokeColor         : 'rgba(60,141,188,0.8)',
							pointColor          : '#3b8bba',
							pointStrokeColor    : 'rgba(60,141,188,1)',
							pointHighlightFill  : '#fff',
							pointHighlightStroke: 'rgba(60,141,188,1)',
							data                : vehicle_exit
						}
					]
				}
			})			
		},
		getEntryVehicles(pageNumber, order_by = null, order_type=null){
			this.import_pageNumber = pageNumber;
			this.import_forcepage = pageNumber;
			let url = 'dashboard/vehicles/IM?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
			GDCE_Client.requestApi("GET",url).then(response => {
				this.entry_vehicles = response.data.data;
				this.import_last_page = response.data.last_page;
				this.import_current_page = response.data.current_page;
				this.import_order_type_after_sort = order_type;
				this.import_order_by = order_by;
			}).catch(error => {
				console.log(error);
			});
		},
		getExitVehicles(pageNumber, order_by = null, order_type=null){
			this.export_pageNumber = pageNumber;
			this.export_forcepage = pageNumber;
			let url = 'dashboard/vehicles/EX?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
			GDCE_Client.requestApi("GET",url).then(response => {
				this.exit_vehicles = response.data.data;
				this.export_last_page = response.data.last_page;
				this.export_current_page = response.data.current_page;
				this.export_order_type_after_sort = order_type;
				this.export_order_by = order_by;
			}).catch(error => {
				console.log(error);
			});
		},
		getApplicationStatus(pageNumber, order_by = null, order_type=null){
			this.declaration_pageNumber = pageNumber;
			this.declaration_forcepage = pageNumber;
			let url = 'dashboard/applications?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
			GDCE_Client.requestApi("GET", url).then(response => {
				this.applications = response.data.data;
				this.declaration_last_page = response.data.last_page;
				this.declaration_current_page = response.data.current_page;
				this.declaration_order_type_after_sort = order_type;
				this.declaration_order_by = order_by;				
			}).catch(error => {
				console.log(error);
			});
		},
		getOverStayApplications(pageNumber, order_by = null, order_type=null){
			this.$store.state.loading.status = true;
			this.over_stay_pageNumber = pageNumber;
			this.over_stay_forcepage = pageNumber;
			let url = 'dashboard/over-stay-applications?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
			GDCE_Client.requestApi("GET", url).then(response => {
				this.over_stay_applications = response.data.data;
				this.over_stay_last_page = response.data.last_page;
				this.over_stay_current_page = response.data.current_page;
				this.over_stay_order_type_after_sort = order_type;
				this.over_stay_order_by = order_by;
				this.$store.state.loading.status = false;
			}).catch(error => {
				this.$store.state.loading.status = false;
			});
		},
		getColor(app){
			if(app.destination && app.destination.status === 'Approve'){
				return "#cce5ff";
			}else if(app.destination && app.destination.status === 'Decline'){
				return "#f8d7da";
			}else if(app.lodgement && app.lodgement.status === 'Approve'){
				return "#d4edda";
			}else if(app.lodgement && app.lodgement.status === 'Decline'){
				return "#fff3cd";
			}else {
				return "white";
			}
		},
	}
}
</script>
<style>
	.chart-active {
		color:rgb(0, 0, 0);
	}
</style>
